import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import { ReactNode, useRef, useState } from 'react';
import { CustomDropdown } from '..';

/**
 * Props for the MobileDropdownStyled component
 * @param {ReactNode} children - The dropdown content or a render function that receives the close function
 * @param {string} title - Optional title for the dropdown
 * @param {string} className - Optional additional CSS classes
 * @param {string} iconColors - Optional icon colors (should be fill-color, hover:fill-color)
 */
type Props = {
  children: ReactNode | ((closeDropdown: () => void) => ReactNode);
  title?: string;
  className?: string;
  darkIcon?: boolean;
};

/**
 * Reusable mobile dropdown component with a tune icon trigger
 * and consistent styling
 */
export const MobileDropdownStyled = ({
  children,
  title,
  className = '',
  darkIcon = false,
}: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const anchorEl = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setOpen((previousOpen) => !previousOpen);
  };

  const closeDropdown = () => {
    setOpen(false);
  };

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? 'transition-popper' : undefined;

  return (
    <div className={`font-secondary ${className}`}>
      <div
        className={`flex cursor-pointer items-center justify-center ${darkIcon ? (open ? 'fill-primary-hover' : 'fill-primary hover:fill-primary-hover') : open ? 'fill-white' : 'fill-skyBlue hover:fill-white'}`}
        aria-describedby={id}
        onClick={handleClick}
        ref={anchorEl}
      >
        <TuneIcon
          className={`cursor-pointer p-0.5 transition-all`}
          style={{ fontSize: '30px', fill: 'inherit' }}
        />
      </div>
      <CustomDropdown
        id={id}
        open={open}
        anchorEl={anchorEl.current}
        handleClick={handleClick}
      >
        <div className='relative z-20 flex min-w-[200px] flex-col items-start justify-center rounded-lg bg-cloudGray font-secondary xs:min-w-[240px]'>
          {/* Header with title and close button */}
          {/* <div className='inline-flex w-full items-center justify-between p-2 xs:p-3'> */}
          {/* <span className='whitespace-nowrap font-secondary text-primary-dark'>
              {title || t('history.sort_by')}:
            </span> */}
          <div
            onClick={handleClick}
            className='absolute right-2 top-2 cursor-pointer fill-darkSteel hover:fill-gray-400'
          >
            <CloseIcon
              className='px-[1px] pb-[2px] transition-all'
              style={{ fontSize: '22px', fill: 'inherit' }}
            />
          </div>
          {/* </div> */}

          {/* Content */}
          {typeof children === 'function' ? children(closeDropdown) : children}
        </div>
      </CustomDropdown>
    </div>
  );
};
